
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  /*
  Clone the requestor model, instead of using the direct object
  */
  clone<T>(model: T): T | undefined {
    if (!model || Object.keys(model).length <= 0) { return undefined; }
    return JSON.parse(JSON.stringify(model));
  }

  isEqual(s1: string, s2: string, isCaseInsensitive = true) {
    if (!s1 || !s2) { return false; }
    if (!isCaseInsensitive) return s1?.trim() === s2?.trim();
    return s1?.trim()?.toLowerCase() === s2?.trim()?.toLowerCase();
  }

  getFormValidationErrors(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {

      const controlErrors: any = form.controls[key]?.errors;
      if (controlErrors != null) {

        Object.keys(controlErrors).forEach(keyError => {

          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

}
